import { cn } from "../../lib/utils";
import { buttonVariants } from "../Button";

export const CALENDAR_STYLES = {
  root: "p-4",
  months: "flex flex-col sm:flex-row gap-8",
  month: "space-y-4",
  caption: "flex justify-center pt-1 relative items-center mb-2",
  caption_label: "text-sm font-semibold",
  caption_dropdowns: "flex justify-center gap-1",
  nav: "space-x-1 flex items-center",
  nav_button: cn(
    buttonVariants({ variant: "outline" }),
    "h-8 w-8 bg-transparent p-0 opacity-60 hover:opacity-100"
  ),
  nav_button_previous: "absolute left-1",
  nav_button_next: "absolute right-1",
  table: "w-full border-collapse",
  head_row: "flex",
  head_cell: "text-muted-foreground rounded-md w-9 font-medium text-[0.75rem]",
  row: "flex w-full mt-1",
  cell: (mode?: string) =>
    cn(
      "relative p-0 text-center text-sm focus-within:relative focus-within:z-20",
      mode === "range"
        ? "[&:has([aria-selected])]:bg-primary-50 [&:has([aria-selected].day-outside)]:bg-primary-50/60 [&:has(>.day-range-end)]:rounded-r-full [&:has(>.day-range-start)]:rounded-l-full first:[&:has([aria-selected])]:rounded-l-full last:[&:has([aria-selected])]:rounded-r-full"
        : "[&:has([aria-selected])]:rounded-full"
    ),
  day: cn(
    buttonVariants({ variant: "ghost" }),
    "h-10 w-10 p-0 font-normal rounded-full hover:bg-accent aria-selected:opacity-100"
  ),
  day_range_start:
    "day-range-start bg-ticketon-calendar-blue text-white outline outline-2 -outline-offset-2 outline-white",
  day_range_end: "day-range-end bg-ticketon-calendar-blue text-white",
  day_selected_single:
    "bg-ticketon-calendar-blue text-white hover:bg-ticketon-calendar-blue focus:bg-ticketon-calendar-blue",
  day_selected_range: "",
  day_today: "ring-1 ring-primary text-accent-foreground",
  day_outside:
    "day-outside text-muted-foreground/40 hover:bg-accent/30 hover:text-accent-foreground",
  day_disabled: "text-muted-foreground/50",
  day_range_middle: "text-foreground",
  day_hidden: "invisible",
  icon: "h-4 w-4",
  dropdown: "rdp-dropdown bg-card",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_label: "text-sm font-medium",
  dropdown_icon: "ml-2 h-4 w-4",
} as const;
